import { render } from "./search.vue?vue&type=template&id=52f57ebe"
import script from "./search.js?vue&type=script&lang=js"
export * from "./search.js?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=52f57ebe&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__